import React from 'react'
import PropTypes from 'prop-types'
import styles from './ImportantNow.module.scss'
import { CTAButton, Unless } from 'src/Components'
import { KEY_CODES } from 'src/constants/utility'

const propTypes = {
  hide: PropTypes.bool,
  locked: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onClick: PropTypes.func
}

const ImportantNowSpotlight = ({ hide, locked, children, onClick }) => {
  return (
    <Unless condition={hide}>
      <CTAButton
        className={styles.option}
        locked={locked}
        onClick={onClick}
        onKeyDown={e => {
          if ((e.which || e.keyCode) === KEY_CODES.enter) {
            onClick()
          }
        }}
        data-qa='importantNowSpotlightButton'
      >
        {children}
      </CTAButton>
    </Unless>
  )
}

ImportantNowSpotlight.propTypes = propTypes
export default ImportantNowSpotlight
